const awsCredentials = {
  accessKeyId: 'AKIATGXKXNMWACVQYNWB',
  secretAccessKey: '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',
  region: 'us-east-1'
}

const ownerEmail = 'CommunityLockerSS@gmail.com'

export { awsCredentials, ownerEmail }
